export enum EAttachmentType {
  CONTRACT = "contract",
  MOVIMENTS = "moviments",
  MEASUREMENTS = "measurements",
}
